import user from "~/api/user";
import customer from "~/api/customer";
import noteApi from "~/api/note";
import taskApi from "~/api/task";

const getMe = ({ commit }) => {
  user.getMe().then((response) => {
    commit("SET_ME", response.data);
  });
};
const getFamily = ({ state, commit }) => {
  if (!state.customerId || Object.entries(state.family).length) return;
  commit("SET_FAMILY_LOADED", false);
  customer.findFamily(state.customerId).then((response) => {
    commit("SET_FAMILY", response.data);
    commit("SET_FAMILY_LOADED", true);
  });
};

const getNotesCount = ({ state, commit, rootState }) => {
  if (rootState.instance) {
    noteApi.countByInstance(rootState.instance.id, rootState.instance.class).then((response) => {
      commit("SET_NOTES_COUNT", response.data);
    });
  } else if (rootState.category_id) {
    noteApi.countByFamilyAndCategory(state.customerId, rootState.category_id).then((response) => {
      commit("SET_NOTES_COUNT", response.data);
    });
  }
};
const getTasksCount = ({ state, commit, rootState }) => {
  if (rootState.instance) {
    taskApi.getActiveTasksCountByInstance(rootState.instance.id, rootState.instance.class)
      .then((response) => {
        commit("SET_TASKS_COUNT", response.data);
      });
  } else if (rootState.category_id) {
    taskApi.getActiveTasksCountByFamilyCategory(state.customerId, rootState.category_id)
      .then((response) => {
        commit("SET_TASKS_COUNT", response.data);
      });
  }
};

const getAttachablesCount = ({ dispatch }) => {
  dispatch("getTasksCount");
  dispatch("getNotesCount");
};
const reloadNotes = () => {

};

export default {
  reloadNotes,
  getNotesCount,
  getMe,
  getAttachablesCount,
  getFamily,
  getTasksCount,
};
